<!-- TM-1000001915 (B3): render the left nav rail so the 4 NavItems display and are
     clickable. Standard Alpha pattern (EE-ExportType / EA-Project reference): the reusable
     <object-component-navigation-side> two-way-binds activeNavigationItem and emits
     onNavigationItemChange; the content @if blocks below dispatch on the active action.
     activeNavigationItem is defaulted to the first item by the base view's initComponent(). -->
@if (initialized && activeNavigationItem) {
    <div class="cn-commission-model-full mt-3 grid">

        <!-- ===================== NAVIGATION RAIL ===================== -->
        <div class="col-12">
            <object-component-navigation-side
                    [name]="dto?.name || 'Provisionsmodell'"
                    [navigationItems]="navigationItems"
                    [(activeNavigationItem)]="activeNavigationItem"
                    (activeNavigationItemChange)="onNavigationItemChange($event)"
            ></object-component-navigation-side>
        </div>

        <!-- ===================== SECTION CONTENT ===================== -->
        <div class="col-12">

        <!-- ===================== ALLGEMEIN ===================== -->
        @if (activeNavigationItem.action === 'cn.CommissionModel') {

            <!-- Status + Freigabevermerk header (status color via neutral severity; widget badge uses uiColor) -->
            @if (dto) {
                <div class="flex align-items-center gap-3 mb-3 flex-wrap">
                    <span class="text-xl font-medium">{{ dto.name }}</span>
                    @if (dto.status != null) {
                        <!-- TM-1000001915 (B17): color via theme tokens (Aktiv=green/Szenario=blue/
                             Archiviert=grey); falls back to the neutral severity if unmapped. -->
                        <p-tag [value]="statusLabel(dto.status)"
                               [severity]="statusSeverity(dto.status)"
                               [style]="statusColorStyle(dto.status)"></p-tag>
                    }
                    @if (dto.approvedBy) {
                        <span class="text-sm text-600">
                            <i class="fa-regular fa-user-check mr-1"></i>
                            Freigegeben von {{ dto.approvedBy }}
                            @if (dto.approvedAt) {
                                am {{ dto.approvedAt | date:'dd.MM.yyyy HH:mm' }}
                            }
                        </span>
                    }
                </div>
            }

            @if (modelWidget) {
                <!-- TM-1000001915 (B15): refresh the bound dto on save so the header status badge
                     re-renders live (was stale until a hard reload). -->
                <mvs-widget
                        [widgetData]="modelWidget"
                        (onChangedObject)="handleModelChanged($event)">
                </mvs-widget>
            }
        }

        <!-- ===================== REGELN ===================== -->
        @if (activeNavigationItem.action === 'cn.CommissionRule') {
            @if (ruleWidget) {
                <mvs-widget
                        [widgetData]="ruleWidget"
                        (onObjectSelect)="handleRuleSelect($event)">
                </mvs-widget>
            }
        }

        <!-- ===================== ZUORDNUNGEN ===================== -->
        @if (activeNavigationItem.action === 'cn.CommissionModelAssignment') {
            @if (assignmentWidget) {
                <mvs-widget [widgetData]="assignmentWidget"></mvs-widget>
            }
        }

        <!-- ===================== LOGICHOOKS ===================== -->
        @if (activeNavigationItem.action === 'cn.CommissionLogicHook') {
            @if (logicHookWidget) {
                <mvs-widget [widgetData]="logicHookWidget"></mvs-widget>
            }
        }

        </div>
    </div>
}
